import { createSelector } from '@ngrx/store';
import { selectCustomersState } from '../reducers';
import { CustomersState } from '../reducers/customers.reducers';

export const getCustomersTableState = createSelector(
  selectCustomersState,
    (state: CustomersState) => { return { total: state.total, currentPage: state.currentPage, perPage: state.perPage, order: state.order, direction: state.direction, filters: state.filters, includes: state.includes } }
);

export const getCustomers = createSelector(
  selectCustomersState,
    (state: CustomersState) => state.list
);

export const getTotalCustomers = createSelector(
  getCustomersTableState,
    (tableState) => tableState.total
);

export const getCustomersCurrentPage = createSelector(
  getCustomersTableState,
    (tableState) => tableState.currentPage
);

export const getCustomersPerPage = createSelector(
  getCustomersTableState,
    (tableState) => tableState.perPage
);

export const getCustomersOrder = createSelector(
  getCustomersTableState,
    (tableState) => tableState.order
);

export const getCustomersDirection = createSelector(
  getCustomersTableState,
    (tableState) => tableState.direction
);

export const getFilters = createSelector(
  getCustomersTableState,
    (tableState) => tableState.filters
);

export const getCustomerDialogId = createSelector(
  selectCustomersState,
    (state: CustomersState) => state.dialogId
);

export const getSelectionDialogId = createSelector(
  selectCustomersState,
    (state: CustomersState) => state.selectionDialogId
);

export const getSelectedCustomer = createSelector(
  selectCustomersState,
    (state: CustomersState) => state.customer
);

export const getSelectedCustomersCurrentPage = createSelector(
  selectCustomersState,
  (state: CustomersState) => {
    const selectedHours = (state.selectedCustomers || []).map(bl => bl.id);
    return state.list?.filter(bl => selectedHours.includes(bl.id));
  }
);



